import PlayIcon from './playIcon.ui';

export default PlayIcon;
